// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1bfId","selects":"Documents_selects__3PXl3"};